function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 33.0099,
  cy: 17.8269,
  r: 16.3308,
  stroke: "#3C3C3B",
  strokeWidth: 2
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 31.9268,
  y: 4.82886,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  fill: "#9F9A98"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 31.9268,
  y: 28.6587,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  fill: "#9F9A98"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 37.1782,
  y: 5.46777,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "rotate(23.4008 37.1782 5.46777)",
  fill: "#9F9A98"
});

var _ref6 =
/*#__PURE__*/
React.createElement("rect", {
  x: 27.714,
  y: 27.3376,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "rotate(23.4008 27.714 27.3376)",
  fill: "#9F9A98"
});

var _ref7 =
/*#__PURE__*/
React.createElement("rect", {
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "matrix(-0.917749 0.397161 0.397161 0.917749 28.8416 5.46777)",
  fill: "#9F9A98"
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "matrix(-0.917749 0.397161 0.397161 0.917749 38.3058 27.3376)",
  fill: "#9F9A98"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  x: 41.4351,
  y: 7.86987,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "rotate(45 41.4351 7.86987)",
  fill: "#9F9A98"
});

var _ref10 =
/*#__PURE__*/
React.createElement("rect", {
  x: 24.5848,
  y: 24.7202,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "rotate(45 24.5848 24.7202)",
  fill: "#9F9A98"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  x: 23.053,
  y: 9.40186,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "rotate(-45 23.053 9.40186)",
  fill: "#9F9A98"
});

var _ref12 =
/*#__PURE__*/
React.createElement("rect", {
  x: 39.9032,
  y: 26.2522,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "rotate(-45 39.9032 26.2522)",
  fill: "#9F9A98"
});

var _ref13 =
/*#__PURE__*/
React.createElement("rect", {
  x: 46.0081,
  y: 16.7437,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "rotate(90 46.0081 16.7437)",
  fill: "#9F9A98"
});

var _ref14 =
/*#__PURE__*/
React.createElement("rect", {
  x: 22.1782,
  y: 16.7437,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "rotate(90 22.1782 16.7437)",
  fill: "#9F9A98"
});

var _ref15 =
/*#__PURE__*/
React.createElement("rect", {
  x: 45.401,
  y: 21.8992,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "rotate(112.956 45.401 21.8992)",
  fill: "#9F9A98"
});

var _ref16 =
/*#__PURE__*/
React.createElement("rect", {
  x: 23.4585,
  y: 12.6047,
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "rotate(112.956 23.4585 12.6047)",
  fill: "#9F9A98"
});

var _ref17 =
/*#__PURE__*/
React.createElement("rect", {
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "matrix(-0.39003 -0.920802 -0.920802 0.39003 45.401 13.7546)",
  fill: "#9F9A98"
});

var _ref18 =
/*#__PURE__*/
React.createElement("rect", {
  width: 2.16635,
  height: 2.16635,
  rx: 1.08317,
  transform: "matrix(-0.39003 -0.920802 -0.920802 0.39003 23.4585 23.0491)",
  fill: "#9F9A98"
});

var _ref19 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 33.0099,
  cy: 17.827,
  r: 1.66635,
  stroke: "#3C3C3B"
});

var _ref20 =
/*#__PURE__*/
React.createElement("rect", {
  x: 31.9268,
  y: 9.16138,
  width: 2.16635,
  height: 7.58222,
  rx: 1.08317,
  fill: "#3C3C3B"
});

var _ref21 =
/*#__PURE__*/
React.createElement("rect", {
  x: 33.0099,
  y: 19.3586,
  width: 2.16635,
  height: 6.45635,
  rx: 1.08317,
  transform: "rotate(-45 33.0099 19.3586)",
  fill: "#3C3C3B"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.72162 35.8251V25.2641C7.72162 23.619 6.388 22.2854 4.74289 22.2854V22.2854C3.09778 22.2854 1.76416 23.619 1.76416 25.2641V44.7659C1.76416 45.2786 1.9882 45.7657 2.37747 46.0993L12.4391 54.7236C12.8824 55.1035 13.1375 55.6582 13.1375 56.2421V58.0302",
  stroke: "#9F9A98",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.4361 48.5814L9.0642 44.1793C7.91785 43.2399 7.71544 41.564 8.60519 40.3787V40.3787C9.52243 39.1568 11.2566 38.9098 12.4785 39.827L23.8283 48.3469C24.1772 48.6088 24.3748 49.0256 24.3567 49.4614L24.0012 58.0302",
  stroke: "#9F9A98",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.6772 61.8213V59.5718C26.6772 59.0195 26.2295 58.5718 25.6772 58.5718H11.4296C10.8773 58.5718 10.4296 59.0195 10.4296 59.5718V61.8213",
  stroke: "#9F9A98",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.0425 35.8251V25.2641C58.0425 23.619 59.3762 22.2854 61.0213 22.2854V22.2854C62.6664 22.2854 64 23.619 64 25.2641V44.7659C64 45.2786 63.776 45.7657 63.3867 46.0993L53.3251 54.7236C52.8818 55.1035 52.6267 55.6582 52.6267 56.2421V58.0302",
  stroke: "#9F9A98",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.2782 48.6186L56.6148 44.2437C57.7609 43.3042 57.9631 41.6284 57.0734 40.4431V40.4431C56.1561 39.2211 54.4218 38.9741 53.1998 39.8914L41.915 48.3624C41.567 48.6237 41.3703 49.0398 41.3893 49.4745L41.763 58.0301",
  stroke: "#9F9A98",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.087 61.8213V59.5718C39.087 59.0195 39.5347 58.5718 40.087 58.5718H54.3346C54.8869 58.5718 55.3346 59.0195 55.3346 59.5718V61.8213",
  stroke: "#9F9A98",
  strokeWidth: 2,
  strokeLinecap: "round"
});

var SvgFeatureOne8 = function SvgFeatureOne8(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 65,
    height: 63,
    viewBox: "0 0 65 63",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFeatureOne8, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/FeatureOne-8.c36b3e29.svg";
export { ForwardRef as ReactComponent };